import api from './api';

export const statsAPI = {
  /**
   * Récupérer les statistiques du dashboard
   * @returns {Promise}
   */
  getDashboardStats: async () => {
    const response = await api.get('/stats/dashboard');
    return response.data;
  },

  /**
   * Récupérer les statistiques d'un quiz
   * @param {String} quizId - L'ID du quiz
   * @returns {Promise}
   */
  getQuizStats: async (quizId) => {
    const response = await api.get(`/stats/quiz/${quizId}`);
    return response.data;
  },

  /**
   * Récupérer les statistiques d'un étudiant
   * @param {String} studentId - L'ID de l'étudiant
   * @returns {Promise}
   */
  getStudentStats: async (studentId) => {
    const response = await api.get(`/stats/student/${studentId}`);
    return response.data;
  }
};

export default statsAPI;

